import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-online-status',
  templateUrl: './online-status.component.html',
  styleUrls: ['./online-status.component.css']
})
export class OnlineStatusComponent implements OnInit {
  @Input() statusMessage: string;
  @Input() status: string;

  constructor() { }

  ngOnInit() { }

}
